import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSEO } from "@/lib/useSEO";

export default function PaymentCancel() {
  useSEO("Plata anulată | ActeSimplu");
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("order_id");

  return (
    <div className="px-4 max-w-lg mx-auto py-20 text-center">
      <span className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-amber-100 text-amber-600 mb-5">
        <XCircle className="w-8 h-8" />
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white">
        Plata nu a fost finalizată
      </h1>
      <p className="mt-3 text-slate-500 dark:text-slate-400">
        Nu ai fost taxat dacă tranzacția nu a fost confirmată. Poți încerca din nou
        oricând.
      </p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          data-testid="retry-btn"
          onClick={() => navigate(-1)}
          className="rounded-full bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 h-12"
        >
          Încearcă din nou
        </Button>
        <Link to="/">
          <Button variant="outline" className="rounded-full font-semibold px-8 h-12 border-slate-300 w-full">
            Pagina principală
          </Button>
        </Link>
      </div>
    </div>
  );
}
